import * as io from "io-ts";
import { withMessage } from "io-ts-types";
import { Column, Identifier } from "diagnostics-domain/dashboard/type";
export const QuantityResource = io.strict({
  kind: withMessage(io.literal("QUANTITY"), () => "invalid resource kind"),
  identifier: Identifier,
  column: Column,
});

export type QuantityResourceT = io.TypeOf<typeof QuantityResource>;
